export default __webpack_public_path__ + "static/media/image-moon.d287d071.png";